import { Header, LoadingSpinner } from '@components/Generic'
import { observer } from 'mobx-react'
import { useContext, useEffect, useState } from 'react'
import { StoreContext } from '@store/Root.store'

import CountdownTimer from '@/components/CountdownTimer/CountdownTimer'
import { axiosInstance } from '@/methods/axiosConfig'
import { useInterval } from 'usehooks-ts'
import { forceRedirect } from '@/methods/forceRedirect'
import { API_URL } from '@constants/apiUrl'
import { Illustration } from '@/components/Illustration/Illustration'

interface PollingResponse {
  status: 'ready' | 'not-ready'
}

export const EnrollmentVerificationPage = observer(() => {
  const store = useContext(StoreContext)
  const { enrollmentVerificationPage: trans } = store.TranslationsState.translations

  const [isChecking, setIsChecking] = useState(false)
  const [shouldPoll, setShouldPoll] = useState(true)
  const [countdownFinished, setCountdownFinished] = useState(false)

  const handleError = (...error: any[]) => {
    const responseObject = error.find((arg) => arg && arg.response)

    if (responseObject) {
      const errorCode = responseObject.response.data.error

      if (errorCode === 'Transaction.VideoRejected') {
        forceRedirect(`${API_URL}/electronic-id/redirect-on-finish?result=fail&error=${errorCode}`)
      }
    } else {
      forceRedirect(`${API_URL}/electronic-id/redirect-on-finish?result=fail&error=`)
    }
  }

  const checkStatus = async (): Promise<PollingResponse | undefined> => {
    setIsChecking(true)

    try {
      const res = await axiosInstance.get<PollingResponse>(
        `${API_URL}/electronic-id/is-ltqc-ready-to-display`,
        {
          withCredentials: true,
        }
      )

      if (res.data.status && res.data.status === 'ready') {
        setShouldPoll(false)
      }
      return res.data
    } catch (e) {
      console.error(e)

      handleError(e)
    } finally {
      setIsChecking(false)
    }
  }

  useEffect(() => {
    if (!shouldPoll) {
      sessionStorage.removeItem('finalTimestamp')
      store.ScenarioState.nextPage()
    }
  }, [shouldPoll])

  useInterval(
    () => {
      if (!isChecking) {
        checkStatus()
      }
    },
    shouldPoll ? 10000 : null
  )

  return (
    <div className="page-container mobile-m-0">
      {!countdownFinished ? (
        <div className="layout__vertically-centered-container">
          <Illustration type="identity-verification" />
          <Header>{trans.header}</Header>
          <p className="generic__paragraph-centered">{trans.pleaseWait}...</p>

          <CountdownTimer
            countdownSeconds={5 * 60}
            onComplete={() => setCountdownFinished(true)}
            trans={trans}
          />
        </div>
      ) : (
        <div className="layout__vertically-centered-container">
          <Header>{trans.header}</Header>
          <p className="generic__paragraph-centered">{trans.moreTimeNeeded}...</p>
          <LoadingSpinner />
          <p className="generic__paragraph-centered">{trans.pleaseWait}...</p>
        </div>
      )}
    </div>
  )
})
